import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export default function useDebounceCb(handler, t0) {
  const $ = _c(4);
  const delay = t0 === undefined ? 500 : t0;
  let t1;
  let t2;
  if ($[0] !== delay || $[1] !== handler) {
    t1 = () => {
      const timeoutId = setTimeout(() => {
        handler();
      }, delay);
      return () => {
        clearTimeout(timeoutId);
      };
    };
    t2 = [delay, handler];
    $[0] = delay;
    $[1] = handler;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
}